import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {getCourierBusinessId, getUserPhoneNumber} from "../../../helpers/authenticator";
import merchant from "../../../network/services/merchant";
import quick_models from "../../../network/models/quick_models";
import Loader from "react-loaders";


const Settlement = () => {
    const {register, handleSubmit, watch, errors} = useForm();
    const [settlement, setSettlement] = useState();
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        merchant.getCourierSettlementDetails(getCourierBusinessId()).then(response => {
                setSettlement(response.data.data);
                setIsLoading(false);
            }
        ).catch(error => {
            setIsLoading(false);
        });
    }, []);


    let details = {...quick_models.settlementDetailsResponse, ...settlement};

    return (
        <>
            <div className="container">
                <div className="row justify-content-center">
                    {
                        isLoading ? <Loader type="ball-scale-multiple"/> :
                            <div className="col-md-7 align-content-center">
                                <form onSubmit={handleSubmit}>
                                    <ul className="list-unstyled">
                                        <li>
                                            <small className="small-text-grey">Bank / Mobile Money Provider</small>
                                        </li>
                                        <li style={{marginTop: 15}}>
                                            <div className="input-group">
                                                <input type="text"
                                                       name="account_provider"
                                                       className="form-control form-control-lg input-form-alt"
                                                       placeholder="eg. Standard chartered bank"
                                                       ref={register({required: true, min: 9, max: 10})}
                                                       onChange={() => {
                                                       }}
                                                       value={details.account_provider}
                                                       aria-label="Username" aria-describedby="basic-addon1"/>
                                            </div>
                                        </li>
                                        <li>
                                            <small className="small-text-grey">Account Details</small>
                                        </li>
                                        <li style={{marginTop: 15}}>
                                            <div className="input-group">
                                                <input type="text"
                                                       className="form-control form-control-lg input-form-alt"
                                                       ref={register({required: true, min: 9, max: 10})}
                                                       value={details.account_details}
                                                       onChange={() => {
                                                       }}
                                                       name="account_details"
                                                       placeholder="Your account details"
                                                       aria-label="Username" aria-describedby="basic-addon1"/>
                                            </div>
                                        </li>
                                        <p className="text-left small-text-blue text-right">
                                            Save >>
                                        </p>
                                    </ul>

                                </form>
                            </div>
                    }

                </div>
            </div>
        </>
    );
};

export default Settlement;
